<div class="forgot-pwd-page">
  <div class="custom-padding">
    <div class="forgot-pwd-container">
      <div class="forgot-pwd-image">
        <img class="logo" src="/assets/images/Frame4036.png" />
        <img class="logo2" src="/assets/images/logo2.png" />
      </div>
      <span class="forgot-pwd-text text-center">
        {{ "common-keywords.ask-forgot-password" | translate }}
      </span>
      <div class="form-container">
        <form [formGroup]="fg" (submit)="forgotPassword()">
          <div class="control">
            <div class="mt-5 mb-3">
              <p class="retry-text">
                {{ "auth.page-component.forgot-password.message" | translate }}
              </p>
            </div>
            <label class="text-gray">
              {{ "common-keywords.email" | translate }}
            </label>
            <ui-input
              [autofocus]="true"
              type="text"
              formControlName="email"
              [hasError]="
                fg.controls['email'].touched && fg.controls['email'].invalid
              "
            ></ui-input>
          </div>
          <div class="control">
            <ui-button
              class="forgot-pwd-button"
              buttonType="submit"
              size="large"
              type="black"
              [isDisabled]="fg.invalid || !!(loading$ | async) || countdown > 0"
              [loading]="!!(loading$ | async)"
            >
              {{ buttonText }}
            </ui-button>
            <div
              class="account-text text-orange flex justify-center items-center mt-4"
            >
              <ui-icon type="pi-arrow-left" size="medium"></ui-icon>
              <label routerLink="/auth" class="back-login text-orange">
                {{
                  "auth.page-component.forgot-password.lbl.back-to-login"
                    | translate
                }}
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
